import { inject, type Provider } from '@angular/core';
import { getPermissionState } from '@app/reducers/auth/permission.helper';
import { Store } from '@ngrx/store';
import type { AppState } from '@reducers/interfaces';
import { PermissionContext } from '@sb/shared/permission/data-access';

export const providePermissionContext = (): Provider => ({
  provide: PermissionContext,
  useFactory: (): PermissionContext => ({
    state: inject<Store<AppState>>(Store).selectSignal(getPermissionState),
  }),
});
